export const SLA_RULE_NAME_MAP: Record<string, string> = {
  first_response_timeout: '首次响应超时',
  draft_confirm_timeout: '草稿确认超时',
  waiting_start_timeout: '待开始处理超时',
  doing_stale: '处理中停滞',
  customer_confirm_timeout: '客户确认超时',
}

export const SLA_RULE_DESCRIPTION_MAP: Record<string, string> = {
  first_response_timeout: '客户群出现待响应消息后，接待负责人需在时限内接住问题，至少完成回应、分流或建单。',
  draft_confirm_timeout: '工单草稿生成后，接待负责人需确认建单、补充信息或拒绝，避免草稿堆积。',
  waiting_start_timeout: '工单已创建但未开始处理时，接待负责人需督促技术接单或改派。',
  doing_stale: '工单处理中长期无状态变化或处理痕迹时，需提醒负责人推动进展。',
  customer_confirm_timeout: '技术处理完成后待客户确认过久时，接待负责人需跟进客户确认、回访或关闭。',
}

export const SLA_STAGE_LABEL_MAP: Record<string, string> = {
  message: '消息响应',
  draft: '工单草稿',
  ticket: '工单处理',
}

export const SLA_TARGET_ROLE_LABEL_MAP: Record<string, string> = {
  service_owner: '接待负责人',
  service_agent: '接待账号',
  tech_owner: '技术负责人',
}

export function getSlaRuleName(ruleCode: string, fallback?: string): string {
  return SLA_RULE_NAME_MAP[ruleCode] || fallback || ruleCode
}

export function getSlaRuleDescription(ruleCode: string): string {
  return SLA_RULE_DESCRIPTION_MAP[ruleCode] || '未配置业务意义'
}

export function getSlaStageLabel(stage: string): string {
  return SLA_STAGE_LABEL_MAP[stage] || stage || '-'
}

export function getSlaTargetRoleLabel(role: string): string {
  return SLA_TARGET_ROLE_LABEL_MAP[role] || role || '-'
}
